export const TOOLING_TABLE_STYLES = {
    table: {
        style: { color: 'var(--bs-body-color)', backgroundColor: 'var(--bs-body-bg)' },
    },
    headRow: {
        style: {
            minHeight: '40px',
            borderBottom: '2px solid var(--bs-body-color)',
        },
    },
    headCells: {
        style: { padding: '8px', fontSize: '16px', fontWeight: 700 },
    },
    cells: {
        style: { padding: '8px' },
    },
    rows: {
        style: {
            minHeight: '49px',
            fontSize: '16px',
            color: 'var(--bs-body-color)',
            backgroundColor: 'var(--bs-body-bg)',
            borderBottom: '1px solid var(--bs-border-color)',
        },
        stripedStyle: { backgroundColor: 'rgba(0, 0, 0, 0.05)' },
        highlightOnHoverStyle: {
            backgroundColor: 'rgba(0, 0, 0, 0.075)',
            outline: 'none',
        },
    },
};
